import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

// ContractedForm — SOW signed date, final contract value, optional PO,
// first-invoice due date. Per item 1.7 the Contracted transition auto-creates
// a Project + draft invoice; Sprint C completes the project shape and
// Sprint E completes the invoice creation. Sprint B persists the structured
// payload so the downstream creators can read it back.
export default function ContractedForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('contracted')} values={values} onChange={onChange} errors={errors} />;
}
